<template>
  <div
    v-if="opportunityBeingVisited.other.isActive"
    id="other-info"
    class="container"
  >
    <div class="columns">
      <div id="other-box" class="column box">
        <others-title
          :title="otherFormat"
          buttonText="Solicitar"
          :description="description"
          :isCardOpen="isCardOpen"
          @open-card="$emit('open-card', 'other')"
          @close-card="$emit('close-card', 'other')"
        />

        <div class="columns action-details" v-if="isCardOpen">
          <themes
            :themes="[
              'Concursos',
              'Desafios',
              'Hackathons',
              'Mesas-redondas',
              'Outras ações...'
            ]"
          />

          <prerequisites
            :advance="opportunityBeingVisited.other.advance"
            :limitDateForRequests="opportunityBeingVisited.limitDateForRequests"
            :limitDateForActions="opportunityBeingVisited.limitDateForActions"
            :courses="opportunityBeingVisited.other.courses"
            :states="['Brasil Todo']"
          />

          <counterparts
            :treatmentPronoun="opportunityBeingVisited.treatmentPronoun"
            :businessName="opportunityBeingVisited.businessName"
            :logosZipURL="opportunityBeingVisited.page.logosZipURL"
            action="a ação"
          />
        </div>
      </div>
    </div>

    <b-modal :active.sync="isRequestModalActive">
      <other-request-modal :advance="opportunityBeingVisited.other.advance" />
    </b-modal>
  </div>
</template>

<script>
import { descriptions } from "../../../assets/js/actions-descriptions";
import othersTitle from "./card/Title";
import themes from "./card/Themes";
import prerequisites from "./card/Prerequisites";
import counterparts from "./card/Counterparts";
import otherRequestModal from "../request-modal/OtherRequestModal";

export default {
  props: ["opportunityBeingVisited", "isCardOpen"],

  components: {
    othersTitle,
    themes,
    prerequisites,
    counterparts,
    otherRequestModal
  },

  data() {
    return {
      description: "",
      isRequestModalActive: false
    };
  },

  computed: {
    otherFormat(){
      if(this.opportunityBeingVisited.other.format == 'online'){
        return 'Outras Ações (Online)';
      } else if(this.opportunityBeingVisited.other.format == 'faceToFace'){
        return 'Outras Ações (Presencial)';
      } else {
        return 'Outras Ações (Presencial ou Online)';
      }
    }
  },

  mounted() {
    this.description = descriptions.other;
  }
};
</script>

<style scoped>
#other-info {
  margin-top: 3rem;
}
@media (max-width: 1023px) {
  #other-info {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}
#other-box {
  background-color: rgb(242, 242, 242);
}
.action-details {
  padding: 2rem;
}
</style>
